import { useEffect, useState } from "react";
import { Card, Dropdown, Spinner } from 'react-bootstrap';
import './SuppliesList.scss';

const List = ({
    supplies,
    handleSelectSuppliesOrder
}) => {
    const currentYear = new Date().getFullYear();
    const [isInitialized, setIsInitialized] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [availableYears, setAvailableYears] = useState([currentYear]);

    useEffect(() => {
        if (!isInitialized) {
            getAvailableYears();
            setIsInitialized(true);
        }
    }, [supplies]);

    const getAvailableYears = () => {
            const availableYears = new Set();
            availableYears.add(currentYear);
            for (let order of supplies) {
                availableYears.add(new Date(order.updatedAt).getFullYear());
            }
            setAvailableYears([...availableYears.values()]);
    };

    const onSelectedYearChange = (event) => {
        const { value } = event.target;
        const numValue = Number(value);
        setSelectedYear(numValue);
    };

    const getSuppliesForYear = () => {
        return supplies.filter((order) => new Date(order?.updatedAt).getFullYear() === selectedYear);
    };

    return (
        <div className="p-2">
            <div className="d-flex align-items-center">

                <div className="me-auto ps-2 supplies-list-title">
                    Your previous orders
                </div>
                <Dropdown className="pe-2">
                    <Dropdown.Toggle variant="secondary">
                        {selectedYear}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {availableYears.map((value, key) => {
                            return (
                                <Dropdown.Item 
                                    key={`${key}-year-opt`} 
                                    as={'button'}
                                    onClick={onSelectedYearChange}
                                    active={selectedYear === value}
                                    value={value}
                                >
                                    {value}
                                </Dropdown.Item>
                            );
                        })}
                    </Dropdown.Menu>
                </Dropdown>
            </div>

            {isLoading && (
                <>
                    <Spinner animation="border" role="status"></Spinner>
                    <p>Loading Orders...</p>
                </>
            )}
            {!isLoading && (
                <div className="mt-4">
                    {supplies.length > 0 ?
                        (getSuppliesForYear().map((order, key) => {
                            return (
                                <Card 
                                    key={`supply-card-${key}`} 
                                    className="mb-2 p-1 order-selectable"
                                    onClick={() => handleSelectSuppliesOrder(order)}
                                >
                                    <Card.Body className="d-flex justify-content-between align-items-center">
                                        <div className="px-2">
                                            Last update: {new Date(order.updatedAt).toLocaleDateString()}
                                        </div>
                                        <div className="px-2">
                                            Total items: {order.supplies.reduce((total, current) => total += current.quantity, 0)}
                                        </div>
                                        <div className="px-2">
                                            Status: {order.status}
                                        </div>
                                    </Card.Body>
                                </Card>
                            );
                        }))
                        :
                        <Card className="mt-2 mx-2">
                            <Card.Body>No supply order found for the selected year.</Card.Body>
                        </Card>
                    }
                </div>
            )}
        </div>
    );
}

export default List;
